// Master Data
export const SET_MASTER_DATA = 'SET_MASTER_DATA';

// Initial loading for masterData
export const INITIALIZE_COMPLETE = 'INITIALIZE_COMPLETE';
export const INITIALIZE_RESET = 'INITIALIZE_RESET';

// ACTIONS
export const TOGGLE_SIDE_MENU = 'TOGGLE_SIDE_MENU';

// Vehicle Request
export const SET_VEHICLE_REQUEST = 'SET_VEHICLE_REQUEST';
export const SET_VEHICLE_REQUEST_COUNT = 'SET_VEHICLE_REQUEST_COUNT';
export const SET_VEHICLE_REQUEST_LOADER = 'SET_VEHICLE_REQUEST_LOADER';
export const SET_VEHICLE_REQUEST_FILTERS = 'SET_VEHICLE_REQUEST_FILTERS';
export const SET_VEHICLE_REQUEST_PAGINATION = 'SET_VEHICLE_REQUEST_PAGINATION';

// Delivery Request
export const SET_INVOICE_NUMBER_CONSIGNMENT = 'SET_INVOICE_NUMBER_CONSIGNMENT';
export const SET_INVOICE_NUMBER_POD_LIST = 'SET_INVOICE_NUMBER_POD_LIST';
export const SET_INVOICE_REQUEST_LOADER = 'SET_INVOICE_REQUEST_LOADER';
export const SET_INVOICE_NUMBER_LOADER = 'SET_INVOICE_NUMBER_LOADER';
export const SET_INVOICE_NUMBER_DATA = 'SET_INVOICE_NUMBER_DATA';
export const SET_UPLOAD_FILE_LOADER = 'SET_UPLOAD_FILE_LOADER';
export const SET_SELECTED_INVOICE_CN_KEYS = 'SET_SELECTED_INVOICE_CN_KEYS';
export const SET_FILTERED_INVOICE_CNS = 'SET_FILTERED_INVOICE_CNS';

// Ticketing Tool
export const TICKETING_TOOL_VISIBILITY = 'TICKETING_TOOL_VISIBILITY';
export const TICKETING_TOOL_SET_TICKET_DATA = 'TICKETING_TOOL_SET_TICKET_DATA';
export const TICKETING_TOOL_SET_OPEN_RAISE_TICKET = 'TICKETING_TOOL_SET_OPEN_RAISE_TICKET';
export const TICKETING_TOOL_SET_URL = 'TICKETING_TOOL_SET_URL';
export const TICKETING_TOOL_ORG_DATA = 'TICKETING_TOOL_ORG_DATA';
export const SET_PIECE_LEVEL_ACTIONS = 'SET_PIECE_LEVEL_ACTIONS';
export const SET_EVENT_TIMESTAMP = 'SET_EVENT_TIMESTAMP';

// Iframe
export const IFRAME_SET_VISIBILITY = 'IFRAME_SET_VISIBILITY';
export const IFRAME_SET_DIMENSIONS = 'IFRAME_SET_DIMENSIONS';
export const IFRAME_SET_LOADED = 'IFRAME_SET_LOADED';
export const IFRAME_SET_RENDERED = 'IFRAME_SET_RENDERED';
export const IFRAME_SET_CLASSNAME = 'IFRAME_SET_CLASSNAME';
export const IFRAME_SET_SLOT_CLOSE_REQUEST = 'IFRAME_SET_SLOT_CLOSE_REQUEST';
export const SET_DEFAULT_PORTAL = 'SET_DEFAULT_PORTAL';

// Assigned Vehicles
export const SET_ASSIGNED_VEHICLES = 'SET_ASSIGNED_VEHICLES';
export const SET_ASSIGNED_VEHICLES_LOADER = 'SET_ASSIGNED_VEHICLES_LOADER';
export const SET_ASSIGNED_VEHICLES_PAGINATION = 'SET_ASSIGNED_VEHICLES_PAGINATION';

// Assigned Drivers
export const SET_ASSIGNED_DRIVERS = 'SET_ASSIGNED_DRIVERS';
export const SET_ASSIGNED_DRIVERS_LOADER = 'SET_ASSIGNED_DRIVERS_LOADER';
export const SET_ASSIGNED_DRIVERS_PAGINATION = 'SET_ASSIGNED_DRIVERS_PAGINATION';

// Moveable Assets
export const SET_MOVEABLE_ASSETS = 'SET_MOVEABLE_ASSETS';
export const SET_MOVEABLE_ASSETS_LOADER = 'SET_MOVEABLE_ASSETS_LOADER';
export const SET_MOVEABLE_ASSETS_PAGINATION = 'SET_MOVEABLE_ASSETS_PAGINATION';

// Notifications
export const SET_NOTIFICATION_AUTH_TOKEN = 'SET_NOTIFICATION_AUTH_TOKEN';

// Invoices
export const SET_INVOICES_FETCH_LOADING = 'SET_INVOICES_FETCH_LOADING';
export const SET_INVOICES_DATA = 'SET_INVOICES_DATA';
export const SET_INVOICES_FETCH_DATA_ERROR = 'SET_INVOICES_FETCH_DATA_ERROR';
export const SET_INVOICES_FILTERS = 'SET_INVOICES_FILTERS';
export const SET_INVOICES_FETCH_METRICS_LOADING = 'SET_INVOICES_FETCH_METRICS_LOADING';
export const SET_INVOICES_METRICS_DATA = 'SET_INVOICES_METRICS_DATA';
export const SET_INVOICES_FETCH_METRICS_DATA_ERROR = 'SET_INVOICES_FETCH_METRICS_DATA_ERROR';
export const SET_INVOICES_PAGINATION = 'SET_INVOICES_PAGINATION';

// Receivables
export const SET_RECEIVABLES_DATA = 'SET_RECEIVABLES_DATA';
export const SET_RECEIVABLES_INVOICE_DATA = 'SET_RECEIVABLES_INVOICE_DATA';
export const SET_RECEIVABLES_SUMMARY_COUNT = 'SET_RECEIVABLES_SUMMARY_COUNT';
export const SET_RECEIVABLES_LOADER = 'SET_RECEIVABLES_LOADER';
export const SET_RECEIVABLES_FILTERS = 'SET_RECEIVABLES_FILTERS';
export const SET_RECEIVABLES_PAGINATION = 'SET_RECEIVABLES_PAGINATION';
export const SET_PAYOUT_BUCKET_DATA = 'SET_PAYOUT_BUCKET_DATA';
export const SET_INVOICE_MASTER_DATA = 'SET_INVOICE_MASTER_DATA';
export const RESET_RECEIVABLES_DATA = 'RESET_RECEIVABLES_DATA';
export const SET_PAYOUT_BUCKET_COLUMNS = 'SET_PAYOUT_BUCKET_COLUMNS';

// Download Requests
export const SET_DOWNLOAD_REQUESTS_DATA = 'SET_DOWNLOAD_REQUESTS_DATA';
export const SET_DOWNLOAD_REQUESTS_LOADER = 'SET_DOWNLOAD_REQUESTS_LOADER';
export const SET_DOWNLOAD_REQUESTS_FILTERS = 'SET_DOWNLOAD_REQUESTS_FILTERS';
export const SET_DOWNLOAD_REQUESTS_PAGINATION = 'SET_DOWNLOAD_REQUESTS_PAGINATION';

// Payout Events
export const SET_PAYOUT_EVENTS = 'SET_PAYOUT_EVENTS';
export const PAYOUT_EVENTS_LOADING = 'PAYOUT_EVENTS_LOADING';
export const PAYOUT_EVENTS_ERROR = 'PAYOUT_EVENTS_ERROR';
export const SET_COMPUTATION_HEADERS_TO_SHOW = 'SET_COMPUTATION_HEADERS_TO_SHOW';
